import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  LinearProgress,
  Stack,
  Chip
} from '@mui/material';
import { CloudUpload, PlayArrow } from '@mui/icons-material';

const BulkOperations: React.FC = () => {
  const [devices, setDevices] = useState<any[]>([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // Parse CSV file
      setDevices([
        { hostname: 'SW-01', ip: '192.168.1.10', vendor: 'cisco', status: 'pending' },
        { hostname: 'SW-02', ip: '192.168.1.11', vendor: 'cisco', status: 'pending' },
        { hostname: 'SW-03', ip: '192.168.1.12', vendor: 'extreme', status: 'pending' },
      ]);
    }
  };

  const handleGenerateBulk = () => {
    setIsProcessing(true);
    setProgress(0);
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setIsProcessing(false);
          return 100;
        }
        return prev + 10;
      });
    }, 500);
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Bulk Operations
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Generate configurations for multiple devices at once
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Stack spacing={3}>
          <Box>
            <input
              accept=".csv,.xlsx"
              style={{ display: 'none' }}
              id="file-upload"
              type="file"
              onChange={handleFileUpload}
            />
            <label htmlFor="file-upload">
              <Button
                variant="outlined"
                component="span"
                startIcon={<CloudUpload />}
              >
                Upload Device List (CSV/Excel)
              </Button>
            </label>
          </Box>

          {devices.length > 0 && (
            <>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Hostname</TableCell>
                      <TableCell>IP Address</TableCell>
                      <TableCell>Vendor</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {devices.map((device, index) => (
                      <TableRow key={index}>
                        <TableCell>{device.hostname}</TableCell>
                        <TableCell>{device.ip}</TableCell>
                        <TableCell>
                          <Chip label={device.vendor} size="small" />
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={device.status}
                            size="small"
                            color={device.status === 'completed' ? 'success' : 'default'}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box>
                <Button
                  variant="contained"
                  startIcon={<PlayArrow />}
                  onClick={handleGenerateBulk}
                  disabled={isProcessing}
                >
                  Generate All Configurations
                </Button>
                {isProcessing && (
                  <Box sx={{ mt: 2 }}>
                    <LinearProgress variant="determinate" value={progress} />
                    <Typography variant="caption" sx={{ mt: 1 }}>
                      Processing... {progress}%
                    </Typography>
                  </Box>
                )}
              </Box>
            </>
          )}
        </Stack>
      </Paper>

      <Alert severity="info">
        Upload a CSV file with columns: hostname, ip_address, vendor, template_name
      </Alert>
    </Box>
  );
};

export default BulkOperations;